import { Box, Grid, GridItem, Heading, Text } from '@chakra-ui/react'
import { DashboardLoading } from 'components/atoms/DashboardLoading'
import { DashboardNotFound } from 'components/atoms/DashboardNotFound'
import { CustomPieChart } from 'components/molecules/CustomPieChart'
import { useInstitutionsContext } from 'contexts/institutions'
import { memo, useEffect, useState } from 'react'
import { getClosureDashboards } from 'services/dashboard'
import formatter from 'utils/formatter'
import { useDebounce } from 'utils/useDebounce'
import { ClosureFilterDTO, DashboardClosureResponseDTO } from '../../types'

interface PropsModeDashboard {
    filter: ClosureFilterDTO
    idDashboard: string
}

const ModeDashboard: React.FC<PropsModeDashboard> = memo(
    ({ filter, idDashboard }) => {
        const [dashboardData, setDashboardData] =
            useState<DashboardClosureResponseDTO>({
                dados: []
            })
        const [loading, setLoading] = useState<boolean>(true)
        const { currentInstitution, currentAgent } = useInstitutionsContext()

        const fetchDashboard = async () => {
            try {
                setLoading(true)
                const response = await getClosureDashboards(
                    { ...filter, cnpjAgente: currentAgent?.cnpj ?? '' },
                    currentInstitution?.id
                )
                if (response?.data) {
                    setDashboardData(response.data)
                } else {
                    console.warn('Formato inesperado da resposta:', response)
                    setDashboardData({ dados: [] })
                }
            } catch (error) {
                console.error('Erro ao buscar dados do dashboard:', error)
                setDashboardData({ dados: [] })
            } finally {
                setLoading(false)
            }
        }

        const bounceAPI = useDebounce(fetchDashboard, 1000)

        useEffect(() => {
            setLoading(true)

            if (currentInstitution?.id !== undefined) {
                bounceAPI()
            }
        }, [filter, currentAgent?.cnpj, currentInstitution?.id])

        const CustomTooltipQuantity = ({ active, payload }: any) => {
            if (active && payload && payload.length) {
                const { nome, taxaRegistro, valorRegistradora } =
                    payload[0].payload
                return (
                    <Box
                        bg="white"
                        border="1px solid #ddd"
                        p={2}
                        borderRadius="md"
                        shadow="sm"
                    >
                        <Text fontWeight="bold">{nome}</Text>
                        <Box
                            display="flex"
                            gap="4px"
                            justifyContent="space-between"
                        >
                            <Text>Total Taxa Registro: </Text>
                            <Text fontWeight="bold">
                                {formatter.moeda(taxaRegistro)}
                            </Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Text>Valor Registradora: </Text>
                            <Text fontWeight="bold">
                                {formatter.moeda(valorRegistradora)}
                            </Text>
                        </Box>
                    </Box>
                )
            }
            return <></>
        }

        if (loading) {
            return <DashboardLoading />
        }

        return (
            <div id={idDashboard}>
                {dashboardData?.dados?.length > 0 ? (
                    <Grid
                        templateColumns="repeat(auto-fit, minmax(500px, 1fr))"
                        gap={6}
                    >
                        {dashboardData?.dados.map((item, index) => (
                            <GridItem key={index}>
                                <Box
                                    bg="white"
                                    borderRadius="md"
                                    shadow="lg"
                                    p={6}
                                    transition="all 0.3s"
                                    _hover={{ shadow: 'xl' }}
                                >
                                    <Heading size="md" textAlign="center">
                                        Desempenho dos Serviços Mensais/Anuais
                                    </Heading>

                                    <CustomPieChart
                                        fontSize={16}
                                        dataKey="quantidade"
                                        outerRadius={180}
                                        values={item.values}
                                        children={CustomTooltipQuantity}
                                    />
                                </Box>
                            </GridItem>
                        ))}
                    </Grid>
                ) : (
                    <DashboardNotFound />
                )}
            </div>
        )
    }
)

export default ModeDashboard
